import { cn } from 'lib/helpers/utility';

import Checkbox from 'components/shared/Checkbox/Checkbox';

import { DOCUMENTS } from '../lib/constants';

import DocumentItem from './DocumentItem';

const DocumentPicker = ({
  documents = DOCUMENTS,
  hasSelection,
  areAllSelected,
  isSelected,
  toggleAll,
  toggleDocument,
  onPreview,
  className
}) => (
  <div className={cn('flex w-full flex-col gap-4', className)}>
    <Checkbox
      id="select-all-documents"
      label="Select all documents"
      isChecked={hasSelection}
      isPartial={!areAllSelected}
      onChange={toggleAll}
    />
    <div className="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(max(252px,45%),1fr))]">
      {documents.map((item) => (
        <DocumentItem
          key={item.id}
          {...item}
          checked={isSelected(item.id)}
          onSelect={toggleDocument}
          onPreview={onPreview}
        />
      ))}
    </div>
  </div>
);

export default DocumentPicker;
